export default __webpack_public_path__ + "static/img11-aea4d41a4a8915fcad0047c44b561b87.webp";